import http from './Http';

/**
 * Datos del documento del docente y la comparativa guardada
 * (comparativa = null si todavía no se generó).
 * Devuelve null si la sesión no se generó a partir de un documento.
 */
const obtenerDocumentoDeSesion = async (sesionId) => {
  try {
    const { data } = await http.get(`/documento-docente/sesion/${sesionId}`);
    return data;
  } catch (error) {
    if (error?.response?.status === 404) {
      return null;
    }
    throw error;
  }
};

/**
 * PDF original del docente como Blob.
 */
const obtenerPdfDocumentoDeSesion = async (sesionId) => {
  const { data } = await http.get(
    `/documento-docente/sesion/${sesionId}/archivo`,
    { responseType: 'blob' }
  );
  return data;
};

/**
 * Compara el documento del docente con la sesión generada.
 * Si ya existe, el backend la devuelve sin volver a llamar a la IA.
 */
const generarComparativa = async (sesionId, { regenerar = false } = {}) => {
  const { data } = await http.post(
    `/documento-docente/sesion/${sesionId}/comparativa`,
    null,
    { params: { regenerar } }
  );
  return data;
};

/**
 * Descarga la comparativa en PDF.
 */
const descargarComparativaPdf = async (sesionId, nombreSesion = '') => {
  const { data } = await http.get(
    `/documento-docente/sesion/${sesionId}/comparativa/pdf`,
    { responseType: 'blob' }
  );

  const url = window.URL.createObjectURL(
    new Blob([data], { type: 'application/pdf' })
  );
  const a = document.createElement('a');
  a.href = url;
  a.download = `Comparativa - ${nombreSesion || 'sesion'}.pdf`.replace(/[\\/:*?"<>|]/g, '-');
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

const documentoDocenteService = {
  obtenerDocumentoDeSesion,
  obtenerPdfDocumentoDeSesion,
  generarComparativa,
  descargarComparativaPdf,
};

export default documentoDocenteService;
